import classNames from 'classnames'
import {cssVars, dataProps, withClassNames} from 'quickstart/theme'
import {ComponentProps} from 'react'
import S from './styles.module.scss'

interface DigestProps extends ComponentProps<'div'> {
  as?: any
}

const _Digest = ({as = 'div', ...props}: DigestProps) => {
  const AsComponent = as as 'div'
  return (
    <AsComponent {...props} className={classNames(S.digest, props.className)} />
  )
}

interface GroupProps extends ComponentProps<'div'> {
  background?: string
  foreground?: string
  size?: 'small' | 'medium' | 'large'
  linkColor?: string
}

const Group = ({
  background: backgroundColor = '',
  foreground: color = '',
  linkColor,
  size = 'large',
  ...props
}: GroupProps) => (
  <div
    {...dataProps({size})}
    {...props}
    className={classNames(S.group, props.className)}
    style={{
      backgroundColor,
      color,
      ...(linkColor && {[cssVars.colors.link]: linkColor}),
      ...props.style,
    }}
  />
)

const Heading = withClassNames(S.heading)('div')

const Snippet = withClassNames(S.snippet)('div')

export const Digest = Object.assign(_Digest, {Group, Heading, Snippet})
